import { layoutTawkIframes, pulseTawkLayout } from './layout';
import { callTawk, tawk } from './session';

export function closeTawkChat() {
  tawk.wantVisible = false;
  tawk.pendingMaximize = false;
  callTawk('minimize');
  callTawk('hideWidget');
  layoutTawkIframes();
  if (typeof tawk.notifyClosed === 'function') tawk.notifyClosed();
}

export function openTawkChat() {
  tawk.wantVisible = true;
  tawk.pendingMaximize = true;
  const api = window.Tawk_API;
  try {
    if (typeof api?.showWidget === 'function') api.showWidget();
    if (typeof api?.maximize === 'function') {
      api.maximize();
      tawk.pendingMaximize = false;
    }
  } catch {
    // Widget may not be ready yet; onLoad will retry.
  }
  layoutTawkIframes();
  pulseTawkLayout();
}
